import {createSlice} from '@reduxjs/toolkit'
import { ROUTE_PATH } from '../../app/constants'
import {setDefaultRegistryNumber} from './rjscSearchSlice'

const initState = {
    header : "Select the business name you want to appear on your licence.",
    text : [
       "Your legal name and any operating/business names registered under Nova Scotia Registry of Joint Stock Companies (RJSC) will appear on this list.",
       "Select the legal name from RJSC that you want to appear on your licence."
    ],
    navigation : {
        next : ROUTE_PATH.RJSC_DETAIL_REVIEW
    }
}

const rjscSearchResultSlice = createSlice({
    name: 'rjscSearchResult',
    initialState : initState,
    reducers : {
        setCompanyRjscRegistryNumber (state, action) {
            state.companyRjscRegistryNumber = action.payload
        }
    },
    extraReducers : (builder) => {
        builder
            .addCase(
                setDefaultRegistryNumber,
                (state, action) => {
                    if(Array.isArray(action.payload) && 
                        action.payload.length > 0 && 
                        action.payload[0].businessEntity && 
                        action.payload[0].businessEntity.registryNumber)
                    state.companyRjscRegistryNumber = action.payload[0].businessEntity.registryNumber
                })
    }
})

export const { setCompanyRjscRegistryNumber } = rjscSearchResultSlice.actions

export default rjscSearchResultSlice.reducer